
export default {
  namespaced: true,
  state: {
    currentSource: null,
  },
  getters: {},
  mutations: {
    setCurrentSource(state, val) {
      console.log(val)
      state.currentSource = val
    },
  },
  actions: {},
}
